module.exports = __webpack_public_path__ + "img/bookmarks2.7b20f9af.svg";